import vue from 'vue'
import {
  Button,
  Toast,
  Indicator,
  MessageBox,
  Loadmore,
  Progress,
  Navbar,
  TabItem,
  Header,
  TabContainer,
  TabContainerItem,
  InfiniteScroll,
  Popup,
  Picker,
  Swipe,
  SwipeItem,
  Lazyload,
  Spinner
} from 'mint-ui'
vue.use(InfiniteScroll)
vue.use(Lazyload)
vue.component(Button.name, Button)
vue.component(Loadmore.name, Loadmore)
vue.component(Progress.name, Progress)
vue.component(Navbar.name, Navbar)
vue.component(TabItem.name, TabItem)
vue.component(Popup.name, Popup)
vue.component(TabContainer.name, TabContainer)
vue.component(TabContainerItem.name, TabContainerItem)
vue.component(Header.name, Header)
vue.component(Picker.name, Picker)
vue.component(Swipe.name, Swipe)
vue.component(SwipeItem.name, SwipeItem)
vue.component(Spinner.name, Spinner)
export default{
  Toast,
  Indicator,
  MessageBox
}



// WEBPACK FOOTER //
// ./src/lib/mint-ui.js